import { init, configureScope } from '@sentry/browser'
import {
  ENV,
  PROD_GA_TRACKING,
  NON_PROD_GA_TRACKING,
  SENTRY_DSN,
} from './config'
import { hijackEffects } from 'stop-runaway-react-effects'

if (ENV !== 'production') {
  hijackEffects()
}

if (ENV === 'production') {
  init({
    dsn: SENTRY_DSN,
  })

  configureScope((scope) => {
    scope.setUser({
      email: window.localStorage.getItem('arc.email'),
      username: window.localStorage.getItem('arc.username'),
    })

    scope.setExtra('authority', window.localStorage.getItem('arc.authority'))
    scope.setExtra(
      'environment',
      window.localStorage.getItem('arc.environment')
    )
    scope.setExtra('groups', window.localStorage.getItem('arc.groups'))
    scope.setExtra(
      'organization',
      window.localStorage.getItem('arc.organization')
    )
  })
}
